Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconLinkData: "data:image/svg+xml,%3csvg id='art' xmlns='http://www.w3.org/2000/svg' width='24' height='12'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:currentColor%7d%3c/style%3e%3c/defs%3e%3cpath class='cls-1' d='M18.11 0H14a1 1 0 000 2h4.11A3.94 3.94 0 0122 6a3.94 3.94 0 01-3.89 4H14a1 1 0 000 2h4.11A6 6 0 0024 6a6 6 0 00-5.89-6zM10 10H5.89A3.94 3.94 0 012 6a3.94 3.94 0 013.89-4H10a1 1 0 000-2H5.89A6 6 0 000 6a6 6 0 005.89 6H10a1 1 0 000-2z'/%3e%3cpath class='cls-1' d='M6 6a1 1 0 001 1h10a1 1 0 000-2H7a1 1 0 00-1 1z'/%3e%3c/svg%3e",
  iconLinkWidth: 24,
  iconLinkHeight: 12
};